import { BaseMark } from './base/BaseMark';

export class Underline extends BaseMark {
  constructor() {
    super('underline');
  }

  get schema() {
    return {
      parseDOM: [{ tag: 'u' }],
      toDOM() {
        return ['u', 0] as const;
      },
    };
  }
}
